const topNavToggleItems = [
  {
    sandbox: '/dashboard/applications/sandbox',
    live: '/dashboard/applications/live',
  },
  {
    sandbox: '/dashboard/dashboard/sandbox',
    live: '/dashboard/dashboard/live',
  },
  { sandbox: '/dashboard/webhooks/sandbox', live: '/dashboard/webhooks/live' },
  { sandbox: '/dashboard/errors/sandbox', live: '/dashboard/errors/live' },
  {
    sandbox: '/dashboard/transactions/sandbox',
    live: '/dashboard/transactions/live',
  },
]

const redirectLinkPersonalDevelopAccounts = [
  {
    sandbox: '/applications/sandbox/create',
    live: '/applications/live/create',
  },
  {
    sandbox: '/applications/createbtcredSandbox',
    live: '/applications/createbtcredlive',
  },
]

const unauthorizedLiveEnvToggleUrls = [
  {
    url: '/applications/braintreeCredentials/editbtcred',
    urlType: 'apps&credentials',
  },
  {
    url: '/applications/braintreeCredentials/editbtcredLive',
    urlType: 'apps&credentials',
  },
  {
    url: '/applications/edit/*',
    urlType: 'apps&credentials',
    exceptionUrlContainsParameters: 'accountWebhooks=true',
  },
  {
    url: '/accounts/create',
    urlType: 'sandboxAccounts',
  },
  {
    url: '/accounts/edit/*',
    urlType: 'sandboxAccounts',
  },
  {
    url: '/accounts/create/custom',
    urlType: 'sandboxAccounts',
  },
  {
    url: '/accounts',
    urlType: 'home',
  },
  {
    url: '/notifications',
    urlType: 'home',
  },
  {
    url: '/webhooksSimulator',
    urlType: 'home',
  },
]
export {
  topNavToggleItems,
  redirectLinkPersonalDevelopAccounts,
  unauthorizedLiveEnvToggleUrls,
}
